export default function Grain() {
  return <div className="grain-overlay" aria-hidden="true" data-testid="film-grain" />;
}
